// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sizeSelectorContainer {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

.sizeSelector {
	display: flex;
	flex-direction: column;
	padding: 1vh;
	background-color: white;
	font-size: 3vh;
}
.sizeSelectorHeader{
	display: flex;
	margin-bottom: 2vh;
}
.sizeSelectorTitle{
	flex: auto;
	margin-right: 5vh;
}
.sizeSelectorHeaderControls{

}
.sizeSelectorHeaderControls:hover{
	cursor: pointer;
	background-color: whitesmoke;
}
.sizeSelectorContent{
    display: flex;
    justify-content: center;
    align-items: center;
	padding: 3vh;
}
.sizeSelectorSelect{
	min-width: 20vh;
    min-height: 4vh;
}
.sizeSelectorButtons{
	flex: 1;
	display: flex;
	justify-content: flex-end;
}
.sizeSelectorButton{
    padding: 1vh;
    margin: 1vh;
    min-width: 5vh;
}
.sizeSelectorButton:hover{
	cursor: pointer;
	background-color: whitesmoke;
}`, "",{"version":3,"sources":["webpack://./src/project/js/sizeSelector/sizeSelector.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;CACR,oCAAoC;CACpC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,uBAAuB;CACvB,cAAc;AACf;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,iBAAiB;AAClB;AACA;;AAEA;AACA;CACC,eAAe;CACf,4BAA4B;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB,YAAY;AACb;AACA;CACC,eAAe;IACZ,eAAe;AACnB;AACA;CACC,OAAO;CACP,aAAa;CACb,yBAAyB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;AACA;CACC,eAAe;CACf,4BAA4B;AAC7B","sourcesContent":[".sizeSelectorContainer {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tright: 0;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.sizeSelector {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tpadding: 1vh;\r\n\tbackground-color: white;\r\n\tfont-size: 3vh;\r\n}\r\n.sizeSelectorHeader{\r\n\tdisplay: flex;\r\n\tmargin-bottom: 2vh;\r\n}\r\n.sizeSelectorTitle{\r\n\tflex: auto;\r\n\tmargin-right: 5vh;\r\n}\r\n.sizeSelectorHeaderControls{\r\n\r\n}\r\n.sizeSelectorHeaderControls:hover{\r\n\tcursor: pointer;\r\n\tbackground-color: whitesmoke;\r\n}\r\n.sizeSelectorContent{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\tpadding: 3vh;\r\n}\r\n.sizeSelectorSelect{\r\n\tmin-width: 20vh;\r\n    min-height: 4vh;\r\n}\r\n.sizeSelectorButtons{\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n}\r\n.sizeSelectorButton{\r\n    padding: 1vh;\r\n    margin: 1vh;\r\n    min-width: 5vh;\r\n}\r\n.sizeSelectorButton:hover{\r\n\tcursor: pointer;\r\n\tbackground-color: whitesmoke;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
